import { Node, mergeAttributes } from '@tiptap/core'
import { VueNodeViewRenderer } from '@tiptap/vue-3'
import InlineChartNode from './InlineChartNode.vue'
import LZS from 'lz-string'

export default Node.create({
  name: 'inline-chart',
  group: 'inline',
  inline: true,
  atom: true,

  addAttributes() {
    return {
      serialized: {
        default: {},
        parseHTML: element => {
          const raw = element.getAttribute('serialized')
          if (!raw) return {}
          try {
            const decompressed = LZS.decompressFromEncodedURIComponent(raw)
            return JSON.parse(decompressed || '{}')
          } catch {
            return {}
          }
        },
        renderHTML: attributes => {
          if (!attributes.serialized) return {}
          const jsonString = JSON.stringify(attributes.serialized)
          const compressed = LZS.compressToEncodedURIComponent(jsonString)
          return {
            serialized: compressed,
          }
        },
      },
    }
  },

  parseHTML() {
    return [{ tag: 'inline-chart' }]
  },

  renderHTML({ HTMLAttributes }) {
    return ['inline-chart', mergeAttributes(HTMLAttributes)]
  },

  addNodeView() {
    return VueNodeViewRenderer(InlineChartNode)
  },
})
